import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  error: {
    id: 'geolocation.error',
    defaultMessage: 'Virhe',
  },
  geolocationNotSupported: {
    id: 'geolocation.geolocationNotSupported',
    defaultMessage: 'Laitteesi ei tue sijaintitiedon hakemista, syötä tiedot käsin',
  },
  geolocationNotAvailable: {
    id: 'geolocation.geolocationNotAvailable',
    defaultMessage: 'Laitteen sijaintitietoa ei saatavilla, sijainti ei ole käytössä',
  },
  geolocationFailed: {
    id: 'geolocation.geolocationFailed',
    defaultMessage: 'Sijainnin paikannus epäonnistui',
  },
})
